import React from 'react';
import PageWrapper from "../../components/page-wrapper/page-wrapper";
import {resourceLinks} from "./constants";
import ResourceCard from "../../components/resource-card/resource-card";
import HeadingUnderline from "../../components/heading-underline/heading-underline";

const ResourcesPage = () => {
    return (
        <PageWrapper>
            <div className="container py-5">
                <div className="row mb-5">
                    <div className="col-lg-8 mx-auto text-center">
                        <h1 className="display-4 text-red mb-4">VEDS Resources</h1>
                        <HeadingUnderline width="25%" />
                        <p className="lead">
                            These resources provide valuable information and support for those affected by
                            Vascular Ehlers-Danlos Syndrome (VEDS). Explore these organizations to learn more
                            about research, community support, and educational materials.
                        </p>
                    </div>
                </div>
                
                <div className="row g-4">
                    {resourceLinks.map((resource) => (
                        <div className="col-md-6" key={`resource-link-${resource.name}`}>
                            <ResourceCard resource={resource} />
                        </div>
                    ))}
                </div>
            </div>
        </PageWrapper>
    );
};

export default ResourcesPage;